import { useMemo } from 'react';
import { useLocales } from 'src/locales';
import SvgColor from 'src/components/svg-color';
import { useNavSettings } from 'src/contexts/nav-bar/nav-setting-context';

// ----------------------------------------------------------------------
const icon = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const icon1 = (name) => (
    <SvgColor src={`/assets/icons/navbar/${name}.png`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
    people: icon1('people'),
    global: icon1('global'),
    job: icon('ic_job'),
    blog: icon('ic_blog'),
    chat: icon('ic_chat'),
    mail: icon('ic_mail'),
    user: icon('ic_user'),
    file: icon('ic_file'),
    lock: icon('ic_lock'),
    tour: icon('ic_tour'),
    order: icon('ic_order'),
    label: icon('ic_label'),
    blank: icon('ic_blank'),
    kanban: icon('ic_kanban'),
    folder: icon('ic_folder'),
    banking: icon('ic_banking'),
    booking: icon('ic_booking'),
    invoice: icon('ic_invoice'),
    product: icon('ic_product'),
    calendar: icon('ic_calendar'),
    disabled: icon('ic_disabled'),
    external: icon('ic_external'),
    menuItem: icon('ic_menu_item'),
    ecommerce: icon('ic_ecommerce'),
    analytics: icon('ic_analytics'),
    dashboard: icon('ic_dashboard'),
    clipboard: icon('ic_clipboard'),
    incident: icon('ic-incident'),
    arrows: icon('ic-change-req'),
    uppdownArrows: icon('ic-priority'),
    team: icon('ic-Response'),
    calendar2: icon('ic-Quarterly'),
    Survey: icon('ic-Survey'),
    Analysis: icon('ic-Analysis'),
    Inventory: icon('ix-Inventory'),
    Budget: icon('ic-Budget'),
    Learning: icon('ic-Learning'),
    dataManagement: icon('ic_data_managemet'),
};



export function useRiskNavData() {
    const { t } = useLocales();
    const {selectedLabels} = useNavSettings()

    const data = useMemo(
        () => {
            const shouldShowMenuItem = (title) => {
                const cleanTitle = title.replace(t(''), '');
                return selectedLabels[cleanTitle] === false;
            };

            const filterChildren = (children) => {
                if (!children) return undefined;
                const filteredChildren = children.filter(child => 
                    shouldShowMenuItem(child.title)
                );
                return filteredChildren.length > 0 ? filteredChildren : undefined;
            };
            const processedItems = [
                {
                    items: [
                        {
                            title: t('Customers'),
                            path: '/accounts-management/customers',
                            icon: ICONS.people,
                        },
                        {
                            title: t('Vendors'),
                            path: '/accounts-management/vendors',
                            icon: ICONS.global,
                        },
                        {
                            title: t('Budget'),
                            path: '/accounts-management/data-management',
                            icon: ICONS.dataManagement,
                            children: filterChildren([
                                {
                                    title: t('Proposals'),
                                    path: '/accounts-management/data-management/proposal', 
                                    //icon: ICONS.file,
                                },
                                {
                                    title: t('Contracts'),
                                    path: '/accounts-management/data-management/project-list/cost-codes',
                                    //icon: ICONS.file,
                                },
                                {
                                    title: t('Change Orders'),
                                    path: '/accounts-management/data-management/project-list/change-order',
                                    //icon: ICONS.file,
                                },
                            ])
                        },
                        {
                            title: t('Accounts Receivable'),
                            path: '/accounts-management/account-receiveable',
                            icon: ICONS.arrows,
                            children: filterChildren([
    
                                {
                                    title: t('Customer Invoices'),
                                    path: '/accounts-management/account-receiveable',
                                    //icon: ICONS.file,
                                },
                                {
                                    title: t('Payment Requisitions'),
                                    path: '/accounts-management/account-receiveable/payment-requisitions',
                                    //icon: ICONS.file,w
                                },
                            ]),
    
                        },
                        {
                            title: t('Accounts Payable'),
                            path: '/accounts-management/accounts-payable',
                            icon: ICONS.chat,
                            children: filterChildren([
                                {
                                    title: t('Purchase Orders'),
                                    path: '/accounts-management/accounts-payable/project-list/purchase-order',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Subcontractors Amount'),
                                    path: '/accounts-management/accounts-payable/project-list/subcontractor-amount',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Work Orders'),
                                    path: '/accounts-management/accounts-payable/project-list/work-orders',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Vendor Invoices'),
                                    path: '/accounts-management/accounts-payable/invoice-page',
                                    //icon: ICONS.arrows, 
                                },
    
                            ],)
                        },
                        {
                            title: t('Expenses /Income'),
                            path: '/accounts-management/expenses',
                            icon: ICONS.uppdownArrows,
                        },
                        {
                            title: t('Payroll'),
                            path: '/accounts-management/payroll-project-list' || '/accounts-management/payroll/genrate-payroll',
                            icon: ICONS.analytics,
                            children: filterChildren([
                                {
                                    title: t('Weekly Payroll Time Sheets'),
                                    path: '/accounts-management/payroll-project-list',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Generate Payroll'),
                                    path: '/accounts-management/payroll/genrate-payroll',
                                    //icon: ICONS.arrows, 
                                },
                                // {
                                //     title: t('Run Payroll'),
                                //     path: '/accounts-management/payroll-project-list/projectlist-runpayroll',
                                //     //icon: ICONS.arrows, 
                                // },
    
                                {
                                    title: t('Payroll taxes'),
                                    path: '/accounts-management/payroll-project-list/payroll/payroll-taxes',
                                    //icon: ICONS.arrows, 
                                },
    
                                {
                                    title: t('Certified Payroll'),
                                    path: '/accounts-management/payroll-project-list/payroll/certified-payroll',
                                    //icon: ICONS.arrows, 
                                },
                            ]),
                        },
                        {
                            title: t('Taxes'),
                            path: '/accounts-management/taxes',
                            icon: ICONS.team,
                            children: filterChildren([
                                {
                                    title: t('Sales Taxes'),
                                    path: '/accounts-management/taxes',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Payroll Taxes'),
                                    path: '/accounts-management/taxes/payrolltaxes',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Business Taxes'),
                                    path: '/accounts-management/taxes/project-list/businesstaxes',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Misc. Taxes'),
                                    path: '/accounts-management/taxes/project-list/misctaxes',
                                    //icon: ICONS.arrows, 
                                },
                            ]),
                        },
                        {
                            title: t('Inventory'),
                            path: '/accounts-management/inventory',
                            icon: ICONS.calendar2,
                            children: [
                                {
                                    title: t('Materials'),
                                    path: '/accounts-management/inventory/materials',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Equipments'),
                                    path: '/accounts-management/inventory/equipments',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Tools'),
                                    path: '/accounts-management/inventory/tools',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Assets'),
                                    path: '/accounts-management/inventory/assets',
                                    //icon: ICONS.arrows, 
                                },
    
                            ],
                        },
                        {
                            title: t('General Ledger'),
                            path: '/accounts-management/general-ledger',
                            icon: ICONS.Survey,
                            children: [
                                {
                                    title: t('General Ledger'),
                                    path: '/accounts-management/general-ledger',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Cash flow Management'),
                                    path: '/accounts-management/general-ledger/cash-flow',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Bank Reconcilition'),
                                    path: '/accounts-management/general-ledger/bank-recognization',
                                    //icon: ICONS.arrows, 
                                },
    
                            ],
                        },
                        {
                            title: t('Balance Sheet'),
                            path: '/accounts-management/balance-sheet',
                            icon: ICONS.Analysis,
                            children: [
                                {
                                    title: t('Balance Sheet'),
                                    path: '/accounts-management/balance-sheet',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('Income Statement'),
                                    path: '/accounts-management/balance-sheet/income-statement',
                                    //icon: ICONS.arrows, 
                                },
                                {
                                    title: t('profit & loss statement'),
                                    path: '/accounts-management/balance-sheet/profit-loss-statement',
                                    //icon: ICONS.arrows, 
                                },
    
                            ],
                        },
                        {
                            title: t('Bank Information'),
                            path: '/accounts-management/bank-information',
                            icon: ICONS.Inventory,
                        },
                        {
                            title: t('Finance Statement'),
                            path: '/accounts-management/finance-tabs',
                            icon: ICONS.Budget,
                        },
                        {
                            title: t('Employees'),
                            path: '/accounts-management/employees',
                            icon: ICONS.file,
                        },
                        // {
                        //     title: t('Reports'),
                        //     path: '/accounts-management/reports',
                        //     icon: ICONS.Learning,
                        //     children: [
                        //         {
                        //             title: t('Tax handling & Reporting'),
                        //             path: '/accounts-management/reports',
                        //             //icon: ICONS.arrows, 
                        //         },
                        //         {
                        //             title: t('Overview'),
                        //             path: '/accounts-management/reports/overview',
                        //             //icon: ICONS.arrows, 
                        //         },
                        //         {
                        //             title: t('Transactions'),
                        //             path: '/accounts-management/reports/transactions',
                        //             //icon: ICONS.arrows, 
                        //         },
    
                        //         {
                        //             title: t('Financial Reporting'),
                        //             path: '/accounts-management/reports/financial-reporting',
                        //             //icon: ICONS.arrows, 
                        //         },
    
                        //         {
                        //             title: t('Report'),
                        //             path: '/accounts-management/reports/report',
                        //             //icon: ICONS.arrows, 
                        //         },
    
                        //         {
                        //             title: t('Budgeting'),
                        //             path: '/accounts-management/reports/budgeting',
                        //             //icon: ICONS.arrows, 
                        //         },
    
                        //         {
                        //             title: t('Assets & Liabilities'),
                        //             path: '/accounts-management/reports',
                        //             //icon: ICONS.arrows, 
                        //         },
    
    
    
                        //     ],
    
    
    
                        // },
                        {
                            title: t('Documents'),
                            path: '/accounts-management/documents',
                            icon: ICONS.Survey,
                        },
                        // {
                        //     title: t('Calendar'),
                        //     path: '/accounts-management/calendar',
                        //     icon: ICONS.Budget,
                        // },
                        {
                            title: t('Audit Logs'),
                            path: '/accounts-management/audit-logs',
                            icon: ICONS.team,
                        },
                        {
                            title: t('Settings'),
                            path: '/accounts-management/settings',
                            icon: ICONS.Analysis,
                        }
                    ].filter(item => !item.children || item.children?.length > 0)
                }
            ];

            return processedItems;
        },
        [t, selectedLabels] 
    );

    return data;
}